export const apiUrl = "https://api.kapfenstein-imbiss.at/v1";
